import fastdom from "fastdom"

const CLASSNAME_CHANGE_TABLE = ".js-change-table"
const CLASSNAME_ACTIVE_TABLE = "forecast-table-tabs__button--active"
const CLASSNAME_ACTIVE_TABLE_VERTICAL_TAB = "forecast-table-vertical-tabs__button--active"
const CLASSNAME_ACTIVE_TABLE_TABS = "forecast-table-table-tabs__button--active"
const CLASSNAME_TABLE_FOOTER = ".js-table-footer"
const CLASSSNAME_UNITS = ".js-units-button"
const CLASSNAME_UNITS_ACTIVE = "forecast-table__units-button--active"
const CLASSNAME_LOADING = "is-loading"

function toggleSpinner(button, onlyRemove = false) {
  if (button.classList.contains(CLASSNAME_LOADING)) {
    fastdom.mutate(() => button.classList.remove(CLASSNAME_LOADING))
    return null
  }

  if (onlyRemove) return null

  return setTimeout(() => fastdom.mutate(() => button.classList.add(CLASSNAME_LOADING)), 350)
}

function toggleActiveClass(buttons, button) {
  fastdom.mutate(() => {
    // Get the table name from the clicked button
    const { tableName } = button.dataset

    // Find ALL buttons across all tab components
    const allButtons = Array.from(document.querySelectorAll(CLASSNAME_CHANGE_TABLE))
    const activeButtons = allButtons.filter((btn) => btn.dataset.tableName === tableName)

    // Remove active class from all buttons across all tab components
    allButtons.forEach((btn) =>
      btn.classList.remove(
        CLASSNAME_ACTIVE_TABLE,
        CLASSNAME_ACTIVE_TABLE_VERTICAL_TAB,
        CLASSNAME_ACTIVE_TABLE_TABS,
      ),
    )

    // Add active class to all buttons for the selected table
    activeButtons.forEach((btn) => {
      // Determine which active class to apply based on the button's parent component
      if (btn.closest(".forecast-table-tabs")) {
        btn.classList.add(CLASSNAME_ACTIVE_TABLE)
      } else if (btn.closest(".forecast-table-vertical-tabs")) {
        btn.classList.add(CLASSNAME_ACTIVE_TABLE_VERTICAL_TAB)
      } else if (btn.closest(".forecast-table-table-tabs")) {
        btn.classList.add(CLASSNAME_ACTIVE_TABLE_TABS)
      }
    })
  })
}

function toggleDisabledButtons(buttons, button) {
  fastdom.mutate(() =>
    buttons.forEach((btn) => {
      if (btn === button) return
      /* eslint-disable-next-line no-param-reassign */
      btn.disabled = !btn.disabled
    }),
  )
}

function applyReplaceTable(container, replaceTable) {
  const buttons = Array.from(document.querySelectorAll(CLASSNAME_CHANGE_TABLE))

  buttons.forEach((button) => {
    const { tableName } = button.dataset
    let timer = null
    let attempts = 0

    button.addEventListener("click", () => {
      timer = toggleSpinner(button)
      toggleDisabledButtons(buttons, button)

      const tfoot = container.querySelector(CLASSNAME_TABLE_FOOTER)
      replaceTable(tfoot.dataset.tableName, tableName, function next(error) {
        if (error) {
          if (error.name === "TableIsRunningError" || error.name === "TableNoTableNodeError") {
            if (attempts < 3) {
              setTimeout(() => {
                replaceTable(tfoot.dataset.tableName, tableName, next)
                attempts += 1
              }, 3000)
              return
            }
          }

          attempts = 0
          clearTimeout(timer)
          timer = toggleSpinner(button, true)
          toggleDisabledButtons(buttons, button)
          return
        }

        attempts = 0
        clearTimeout(timer)
        timer = toggleSpinner(button, true)
        toggleDisabledButtons(buttons, button)

        toggleActiveClass(buttons, button)
      })
    })
  })
}

function applySwitchUnits(container) {
  const buttons = Array.from(container.querySelectorAll(CLASSSNAME_UNITS))

  buttons.forEach((button) => {
    const { units } = button.dataset

    if (units === window.unitsConv.currentUnits) button.classList.add(CLASSNAME_UNITS_ACTIVE)

    button.addEventListener("click", () => {
      window.switchSurfUnits(units)

      buttons.forEach((btn) => btn.classList.remove(CLASSNAME_UNITS_ACTIVE))
      button.classList.add(CLASSNAME_UNITS_ACTIVE)
    })
  })
}

function applyToUIControls(container, changeMode, replaceTable) {
  applyReplaceTable(container, replaceTable)
  applySwitchUnits(container)
}

export default applyToUIControls
